module.exports = __webpack_public_path__ + "img/acacia-outdoor.6a240c06.webp";